var indexOf = [].indexOf;

angular.module('gym.components').directive('contactInformation', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/contact_information.html.slim'),
    scope: {
      contact: '=',
      gocardlessDefaultMandateInvalid: '=',
      formValue: '=',
      form: '=',
      permissions: '=',
      editableSectionName: '=',
      editForm: '&',
      deleteContact: '&',
      saveImage: '&',
      flags: '=',
      addFlag: '&',
      showFlags: '&',
      save: '&',
      cancel: '&',
      manageComms: '&',
      onFlagAdded: '&'
    },
    controller: ["$scope", "$rootScope", "$timeout", "$document", "FormFieldDisplayingService", "ContactBadgeService", "flash", function($scope, $rootScope, $timeout, $document, FormFieldDisplayingService, ContactBadgeService, flash) {
      var isPermissionsAvailable;
      $scope.units = $rootScope.gym.units;
      $scope.isFieldAvailable = function(field) {
        var hiddenFields, ref;
        hiddenFields = ['id', 'first_name', 'last_name', 'prospect_status', 'member_status', 'non_attending_contact_status', 'created_at', 'updated_at', 'owner_id', 'street_address_line_2', 'street_address_city', 'street_address_state', 'street_address_postcode'];
        return FormFieldDisplayingService.isDisplaying($scope.contact.type, field) && (ref = field.name, indexOf.call(hiddenFields, ref) < 0);
      };
      isPermissionsAvailable = function(field) {
        switch (field.name) {
          case 'owner_id':
            return $scope.permissions.change_contact_owner;
          default:
            return true;
        }
      };
      $scope.fieldLabel = function(field) {
        if (field.name === 'street_address_line_1') {
          return 'Address';
        } else {
          return field.label;
        }
      };
      $scope.fieldValue = function(field) {
        if (field.name === 'street_address_line_1') {
          return $scope.contact.address;
        } else {
          return $scope.contact.contact_information[field.name];
        }
      };
      $scope.isEditFieldAvailable = function(field) {
        if (field.archived || field.read_only) {
          return false;
        }
        return FormFieldDisplayingService.isDisplaying($scope.contact.type, field) && isPermissionsAvailable(field);
      };
      $scope.getYears = function() {
        return moment().diff($scope.contact.contact_information.dob, 'years');
      };
      $scope.scrollToWallet = function() {
        return $document.scrollToElementAnimated(angular.element('#walletContainer'));
      };
      $scope.getContactBadge = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.hasPendingCancellation = function() {
        return !!_.find($scope.contact.memberships, function(item) {
          return item.active && item.membership_cancellation;
        });
      };
      $scope.scrollToMemberships = function() {
        return $document.scrollToElementAnimated(angular.element('#memberships-section-container'));
      };
      $scope.selectPhoto = function() {
        angular.element('#contact-photo-input').click();
        return true;
      };
      return $scope.$watch('imageData.file', function(file) {
        var dataUrlReader;
        if (file != null ? file.size : void 0) {
          if (file.size > 5000000) {
            flash.error = 'Image size must be 5MB or lower';
            return;
          }
          dataUrlReader = new window.FileReader();
          dataUrlReader.readAsDataURL(file);
          return dataUrlReader.onloadend = function() {
            return $timeout(function() {
              $scope.imageData.imagePreview = dataUrlReader.result;
              $scope.contact.image = dataUrlReader.result.replace(/^data:image\/\w*;base64,/, '');
              return $scope.saveImage();
            });
          };
        }
      });
    }]
  };
});
